export default __webpack_public_path__ + "static/media/Pic12.7522d7d6.jpg";